import React, { createContext, useContext, useState, useEffect } from 'react';
import { COMPANY, DEFAULT_TERMS } from '../config/company';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    name: COMPANY.name,
    license: COMPANY.license,
    tagline: COMPANY.tagline,
    address: COMPANY.address,
    city: COMPANY.city,
    state: COMPANY.state,
    zip: COMPANY.zip,
    phone: COMPANY.phone,
    email: COMPANY.email,
    website: COMPANY.website,
    defaultTaxRate: COMPANY.defaultTaxRate,
    primaryColor: COMPANY.primaryColor,
    secondaryColor: COMPANY.secondaryColor,
    termsEn: DEFAULT_TERMS.en,
    termsEs: DEFAULT_TERMS.es,
    logo: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/settings`);
        if (response.ok) {
          const data = await response.json();
          setSettings(prev => ({ ...prev, ...data }));
        }
      } catch (error) {
        console.error('Error loading settings:', error);
        // Fall back to localStorage
        const savedSettings = localStorage.getItem('proestimate_settings');
        if (savedSettings) {
          setSettings(prev => ({ ...prev, ...JSON.parse(savedSettings) }));
        }
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const refreshSettings = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/settings`);
      if (response.ok) {
        const data = await response.json();
        setSettings(prev => ({ ...prev, ...data }));
      }
    } catch (error) {
      console.error('Error refreshing settings:', error);
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
